const Helpers = {
  /**
   * Генерирует случайный идентификатор.
   *
   * @param {number} [length=10] - Длина идентификатора.
   * @returns {string} Случайная строка.
   */
  generateID(length = 10) {
    return Math.random().toString(36).substr(2, length);
  },

  /**
   * Форматирует дату в локальный строковый формат.
   *
   * @param {string|number|Date} date - Дата для форматирования.
   * @returns {string} Отформатированная дата.
   */
  formatDate(date) {
    return new Date(date).toLocaleDateString();
  },

  /**
   * Копирует текст в буфер обмена.
   *
   * @param {string} text - Текст для копирования.
   * @returns {Promise<void>} Промис, который выполняется при успешном копировании.
   */
  copyToClipboard(text) {
    return navigator.clipboard.writeText(text).then(
      () => console.log('Скопировано!'),
      (err) => console.error('Ошибка копирования', err)
    );
  },

  /**
   * Выполняет задержку перед продолжением выполнения кода.
   *
   * @param {number} ms - Время задержки в миллисекундах.
   * @returns {Promise<void>} Промис, который выполняется после задержки.
   */
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
};

window.Helpers = Helpers;